import { View, Text } from 'react-native';
import { wordleViewStyles as styles } from './WordleView.styles';
import { WordleBoard } from '../WordleBoard/WordleBoard';
import { WordleKeyboard } from '../WordleKeyboard/WordleKeyboard';
import { WORDLE_WIN_REWARD_COINS, type WordleMark } from '../../../src/quiz/constants/warmup.constants';
import type { WordleGuessRow, WordleStatus } from '../../../src/quiz/helpers/gamesApi';

interface WordleViewProps {
  length: number;
  maxGuesses: number;
  guesses: WordleGuessRow[];
  currentInput: string;
  status: WordleStatus;
  shakeNonce: number;
  keyStates: Record<string, WordleMark>;
  isSubmitting: boolean;
  onKeyPress: (key: string) => void;
  onEnter: () => void;
  onDelete: () => void;
}

export function WordleView(props: WordleViewProps) {
  const { status, isSubmitting } = props;
  const playable = status === 'NOT_STARTED' || status === 'IN_PROGRESS';

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <Text style={styles.title}>Football Wordle</Text>
        <View style={styles.rewardPill}>
          <Text style={styles.rewardPillText}>{WORDLE_WIN_REWARD_COINS}</Text>
        </View>
      </View>

      <View style={styles.boardArea}>
        <WordleBoard
          length={props.length}
          maxGuesses={props.maxGuesses}
          guesses={props.guesses}
          currentInput={props.currentInput}
          status={props.status}
          shakeNonce={props.shakeNonce}
        />
      </View>

      <WordleKeyboard
        keyStates={props.keyStates}
        disabled={!playable || isSubmitting}
        onKeyPress={props.onKeyPress}
        onEnter={props.onEnter}
        onDelete={props.onDelete}
      />
    </View>
  );
}
